import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError, of } from 'rxjs';
import { environment } from '../../environment/environment';
import {
  FilterMetadata,
  FilterFacetCounts,
  createEmptyFacetCounts,
} from './events-filter.model';

@Injectable({ providedIn: 'root' })
export class EventsFilterApiService {
  constructor(private http: HttpClient) {}

  getFilterMetadata(params?: { organization_ids?: string }): Observable<FilterMetadata> {
    const query: Record<string, string> = {};
    if (params?.organization_ids) {
      query['organization_ids'] = params.organization_ids;
    }
    return this.http.get<FilterMetadata>(`${environment.apiUrl}/events/filter-metadata`, {
      params: query,
    });
  }

  getFilterFacets(query: Record<string, string>): Observable<FilterFacetCounts> {
    return this.http.get<unknown>(`${environment.apiUrl}/events/filter-facets`, { params: query }).pipe(
      map((res) => this.normalizeFacetCounts(res)),
      catchError((err) => {
        console.warn('[EventsFilterApi] getFilterFacets failed', err, query);
        return of(createEmptyFacetCounts());
      })
    );
  }

  private normalizeFacetCounts(res: unknown): FilterFacetCounts {
    if (!res || typeof res !== 'object') {
      return createEmptyFacetCounts();
    }
    const raw = res as Record<string, unknown>;
    const payload =
      raw['total'] !== undefined
        ? raw
        : (raw['data'] && typeof raw['data'] === 'object' ? (raw['data'] as Record<string, unknown>) : raw);

    const hidden = payload['hiddenCounts'] as Record<string, number> | undefined;
    return {
      total: Number(payload['total'] ?? 0),
      eventTypes: (payload['eventTypes'] as Record<string, number>) ?? {},
      organizations: (payload['organizations'] as Record<string, number>) ?? {},
      educationalPaths: (payload['educationalPaths'] as Record<string, number>) ?? {},
      modules: (payload['modules'] as Record<string, number>) ?? {},
      locations: (payload['locations'] as Record<string, number>) ?? {},
      hiddenCounts: {
        subEvents: Number(hidden?.['subEvents'] ?? 0),
        fullEvents: Number(hidden?.['fullEvents'] ?? 0),
        participated: Number(hidden?.['participated'] ?? 0),
      },
    };
  }
}
